// src/sim/ai/fear/constants.ts — P4 fear system tunables (D-17..D-22).
// Tick-based at 30 Hz. TODO(P7 POL-06): retune from playtest.
//
// Source: .planning/phases/04-ai/04-CONTEXT.md D-17..D-22; 04-RESEARCH.md Pattern 10.

export const P4_FEAR_NERVOUS = 0.35;
export const P4_FEAR_AFRAID = 0.65;
export const P4_FEAR_TERRIFIED = 0.9;

export const P4_DARK_FEAR_RATE = 0.002;
export const P4_TORCH_OFF_FEAR_MULT = 2;

export const P4_ISOLATION_FEAR_RATE = 0.0015;
export const P4_ISOLATION_NO_SIGHTING_WINDOW_TICKS = 150; // 5 s at 30 Hz
export const P4_ISOLATION_TEAMMATE_RADIUS_TILES = 10;
export const P4_FEAR_DECAY_RATE = 0.001;

export const P4_TRIGGER_FEAR_RATE = 0.004;

export type FearThreshold = 'nervous' | 'afraid' | 'terrified';
